import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

import './index.scss';

const { TextArea } = Input;

export default class TextEditor extends Component {
  componentDidMount() {
    document.addEventListener('selectionchange', () => {
      const selection = window.getSelection();
      if (this.textAreaNode && selection.anchorNode && selection.anchorNode === this.selectionAnchorNode) {
        const selected_range = {
          startIndex: this.textAreaNode.textAreaRef.selectionStart,
          endIndex: this.textAreaNode.textAreaRef.selectionEnd - 1,
        }
        this.props.handleSelectedEntityRange(selected_range);
      }
    }, false);
  }

  renderHighLightEntity = (entity, text, key) => {
    const start = text.substr(0, entity.startIndex);
    const value = text.substr(entity.startIndex, entity.endIndex - entity.startIndex + 1);
    const end = text.substr(entity.endIndex + 1);

    return (
      <div key={key} className={`ori-absolute ori-font-xs textContainer overlapOnInput ${this.props.text_area_class}`}>
        <span>{start}</span>
        <span className={`default-entity entity-${key}`} style={{ opacity: '0.3' }}>{value}</span>
        <span>{end}</span>
      </div>
    );
  }

  render() {
    const { text, entityArray, text_area_class, onChange } = this.props;
    let text_area_props = {};
    if (onChange) text_area_props = { ...text_area_props, onChange };
    return (
      <div className="ori-relative ori-full-width oriTextEditorContainer" ref={(node) => { this.selectionAnchorNode = node; }}>
        <TextArea className={`ori-full-width ori-border-radius-1  textContainer textContent ${text_area_class}`} autosize={{ minRows: 1 }} ref={node => this.textAreaNode = node} value={text} {...text_area_props} />
        {
          entityArray && entityArray.length > 0 &&
          entityArray.map((entity, index) => {
            return this.renderHighLightEntity(entity, text, index)
          })
        }
      </div>
    );
  }
}

TextEditor.propTypes = {
  text: PropTypes.string.isRequired,
  entityArray: PropTypes.array.isRequired,
  handleSelectedEntityRange: PropTypes.func,
  text_area_class: PropTypes.string,
  onChange: PropTypes.func,
};

TextEditor.defaultProps = {
  text_area_class: "ori-font-xs",
};



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/texteditor/index.js